module.exports = __webpack_public_path__ + "img/taste-parallax.703c2395.jpg";